import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { WebsiteBranchLinkContainerModel } from '../../../../../../models/aggregates/cms/website';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
    providedIn: 'root'
})
export class WebsiteBranchLinkService extends BaseApiPublicLoginTemplateService<WebsiteBranchLinkContainerModel, WebsiteBranchLinkContainerModel, WebsiteBranchLinkContainerModel> {

    static readonly WEBSITE_BRANCH_LINK_SUB_PATH = 'website-branch-links/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteBranchLinkService.WEBSITE_BRANCH_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteBranchLinkService.WEBSITE_BRANCH_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteBranchLinkService.WEBSITE_BRANCH_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_EP;
        this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + WebsiteBranchLinkService.WEBSITE_BRANCH_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_ENTITY_EP;
        this.httpClient = http;
    }
}